import type { TemplateRef } from "@shared/dto.ts";

// Confirm dialogs state what a record is used by, so the count needs a reading
// that works at zero and at one.
export const formatUsage = (count: number, noun: string): string =>
  count === 0
    ? `No ${noun}s use it.`
    : `${count} ${noun}${count === 1 ? "" : "s"} use${count === 1 ? "s" : ""} it.`;

// A code is more useful than an id in a refusal a person reads, but not every
// template has one yet.
export const formatTemplateRefs = (templates: readonly TemplateRef[]): string =>
  templates.map((template) => template.code ?? `#${template.id}`).join(", ");
